/**
 * What each stored field is called in French.
 *
 * Display, not data — which is why this lives on the front. The API resolves
 * the ids a diff refers to, because only it can; naming the fields is this
 * side's job, and doing it here means the names inside a sub-document get
 * translated as well as the field that holds it. That was the gap: the box
 * said "Ticket restaurant" while its contents still read "employerShare".
 */
export const FIELD_LABELS = {
  // restaurant ticket
  restaurantTicket: 'Ticket restaurant',
  value: 'Valeur du ticket',
  employerShare: 'Part patronale',
  employer_share: 'Part patronale',
  coef: 'Coef de facturation',
  unit: 'Unité',
  modality: 'Modalité',
  // remuneration
  percentage: 'Majoration',
  start: 'À partir de',
  end: 'Jusqu’à',
  nightHours: 'Heures de nuit',
  overtimes: 'Heures supplémentaires',
  sundayHours: 'Heures du dimanche',
  holidayHours: 'Heures jours fériés travaillés',
  solidarityDay: 'Jour de solidarité',
  coefficients: 'Coefficients de facturation',
  delegation: 'Coefficient de délégation',
  management: 'Coefficient de gestion',
  installations: 'Installations collectives',
  bonus: 'Prime',
  prime: 'Prime',
  payed: 'Montant',
  // company sheet
  reason_social: 'Raison sociale',
  name_commercial: 'Nom commercial',
  siret: 'SIRET',
  code_ape: 'Code APE',
  status: 'Forme juridique',
  staff: 'Effectif',
  conv_collective: 'Convention collective',
  address: 'Adresse',
  street: 'Rue',
  complement: 'Complément',
  postcode: 'Code postal',
  city: 'Ville',
  department: 'Département',
  companySupplier: 'Fournisseur',
  description: 'Brief',
  post_it: 'Post-it',
  phone: 'Téléphone',
  email: 'Email',
  role: 'Rôle',
  firstname: 'Prénom',
  lastname: 'Nom',
  membre: 'Membre',
  collaborateur: 'Collaborateur',
  displayCostEstimate: 'Affichage de l’estimation de coût',
  // found by auditing every field the API can put in a diff
  name: 'Rubrique',
  ref: 'Référence',
  content: 'Contenu',
  postIt: 'Post-it',
  location: 'Adresse',
  message: 'Message',
  bonusAdded: 'Prime',
  // billing information (JBWEB-1268)
  invoice_address: 'Adresse de facturation',
  invoice_address_follows_company: 'Suit l’adresse de l’entreprise',
  payment_term: 'Délai de paiement',
};

/**
 * Fields carried in a diff that say nothing to a reader.
 *
 * Internal keys — the identifiers a record is addressed by, the timestamps a
 * sub-document keeps for itself. Naming them in French would not help: an
 * entry reading "Identifiant de tranche : 3" is noise beside the coefficient
 * that actually moved. Hidden rather than translated.
 */
export const HIDDEN_FIELDS = new Set([
  'bonusId',
  'idEmployee',
  'id_range_coefficient',
  'imported_at',
  'updated_at',
  'updated_by',
  'source',
  '_id',
  '__v',
]);

export const isHiddenField = (field) => HIDDEN_FIELDS.has(field);

/**
 * An unknown field keeps its stored name rather than disappearing: a technical
 * word on screen tells us what to add here, an empty line tells us nothing.
 */
export const labelForField = (field) => FIELD_LABELS[field] ?? field;

export default labelForField;
